export default __webpack_public_path__ + "static/media/item-4.5a372ab3.png";